import { decorate, observable, action } from 'mobx';

import * as Api from '../lib/api';
import { loc } from '../lib/loc';
import { RegisterLoc } from '../loc/register';
import { serializeArray } from '../lib/form';
import { ErrorLoc } from '../loc/error';

export class RegisterStore {
    loaderRegister = false;
    loaderSearch = false;
    errorMessage = '';
    token = null;
    phone = null;
    selectValue = loc(RegisterLoc.country.russia);
    cities = [];
    selectedCity = null;
    company = null;
    confirmed = false;

    clearErrors = () => (this.errorMessage = '');

    clearCompany = () => (this.company = null);

    handleChange = e => (this.selectValue = e.target.value);

    revokeConfirmation = () => (this.confirmed = false);

    setPlaceholder = () => {
        if (this.selectValue === loc(RegisterLoc.country.russia)) return loc(RegisterLoc.form.tin);
        if (this.selectValue === loc(RegisterLoc.country.belarus)) return loc(RegisterLoc.form.unp);
        if (this.selectValue === loc(RegisterLoc.country.kazakhstan)) return loc(RegisterLoc.form.bin);
    };

    registerPrivate = (name, phone, email) => {
        this.loaderRegister = true;
        this.errorMessage = '';

        const data = {
            name,
            contact_phone: phone.match(new RegExp(/[0-9]/g)).join(''),
            contact_email: email,
            city: +this.selectedCity.id,
            utm: 'utm_register_lk',
        };

        Api.fetch('register/private', data, 'PUT')
            .then(data => {
                if (data.success) {
                    this.token = data.result.token;
                }
            })
            .catch(data => {
                this.errorMessage = data.error_description || loc(ErrorLoc.unknownError);
            })
            .finally(() => {
                this.loaderRegister = false;
            });
    };

    registerLegalNew = (e, phone) => {
        this.loaderRegister = true;
        this.errorMessage = '';

        const data = {
            utm: 'utm_register_lk',
            contact_phone: phone.match(new RegExp(/[0-9]/g))?.join(''),
            city: +this.selectedCity.id,
        };
        for (let item of serializeArray(e.target)) {
            data[item.name] = item.value;
        }

        Api.fetch('register/legal', data, 'PUT')
            .then(data => {
                if (data.success) {
                    this.token = data.result.token;
                }
            })
            .catch(data => {
                if (data.error === 'PARAMS_ERROR') {
                    this.errorMessage = Object.entries(data.error_description)
                        .map(([key, value]) => {
                            return `${key} -  ${value[0]}`;
                        })
                        .join(', \n');
                } else {
                    this.errorMessage = data.error_description || loc(ErrorLoc.unknownError);
                }
            })
            .finally(() => {
                this.loaderRegister = false;
            });
    };

    searchCompany = tin => {
        this.errorMessage = '';
        this.loaderSearch = true;
        Api.fetch('register/company', { tin })
            .then(data => {
                if (data.success) {
                    this.company = data.result;
                }
            })
            .catch(data => {
                this.errorMessage = data.error_description || loc(ErrorLoc.unknownError);
            })
            .finally(() => {
                this.loaderSearch = false;
            });
    };

    registerLegalExisting = (e, phone) => {
        e.preventDefault();
        this.loaderRegister = true;
        this.errorMessage = '';

        const data = {
            utm: 'utm_register_lk',
            contact_phone: phone.match(new RegExp(/[0-9]/g)).join(''),
            company_id: this.company.id,
        };
        for (let item of serializeArray(e.target)) {
            data[item.name] = item.value;
        }
        Api.fetch('register/exist', data, 'PUT')
            .then(data => {
                if (data.success) {
                    this.token = data.result.token;
                    this.phone = data.result.phone;
                }
            })
            .catch(data => {
                this.errorMessage = data.error_description || loc(ErrorLoc.unknownError);
            })
            .finally(() => {
                this.loaderRegister = false;
            });
    };

    confirm = code => {
        this.errorMessage = '';
        Api.fetch(
            'register/confirm-user',
            {
                token: this.token,
                code,
            },
            'PUT',
        )
            .then(() => {
                this.confirmed = true;
                this.token = null;
            })
            .catch(data => (this.errorMessage = data.error_description));
    };

    getCities = () => {
        Api.fetch('lists/city')
            .then(data => {
                if (data.success) {
                    this.cities = data.result;
                }
            })
            .catch(data => {
                this.errorMessage = data.error_description || loc(ErrorLoc.unknownError);
            });
    };

    setSelectedCity = city => (this.selectedCity = city);
}

decorate(RegisterStore, {
    loaderRegister: observable,
    loaderSearch: observable,
    errorMessage: observable,
    token: observable,
    selectValue: observable,
    company: observable,
    phone: observable,
    confirmed: observable,
    cities: observable,
    selectedCity: observable,

    registerLegalNew: action,
    registerLegalExisting: action,
    registerPrivate: action,
    handleChange: action,
    setPlaceholder: action,
    searchCompany: action,
    confirm: action,
    clearErrors: action,
    clearCompany: action,
    getCities: action,
    setSelectedCity: action,
});
